<div class="container">
  <div class="news-item" *ngFor="let curNews of news"
  (click)="goToRouter(curNews)">
    <img [src]="'assets/img/news/'+curNews.bgImg" alt="">
    <h3>{{curNews.title}}</h3>
  </div>
</div>
